/**
 * navigator.clipboard is only exposed in secure contexts (https, or a hostname
 * ending in exactly ".localhost"). Dev domains like dashboard-snb.localhost.com
 * are served over http and don't qualify, so it stays undefined there.
 */
const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
        document.execCommand('copy');
    } finally {
        document.body.removeChild(textarea);
    }
    return Promise.resolve();
};

export default {
    copyToClipboard,
};
